import { BellIcon as PhosphorBellIcon } from '@phosphor-icons/react/dist/csr/Bell'
import { ArchiveIcon as PhosphorArchiveIcon } from '@phosphor-icons/react/dist/csr/Archive'
import { CaretDoubleUpIcon as PhosphorCaretDoubleUpIcon } from '@phosphor-icons/react/dist/csr/CaretDoubleUp'
import { CaretLeftIcon as PhosphorCaretLeftIcon } from '@phosphor-icons/react/dist/csr/CaretLeft'
import { CaretRightIcon as PhosphorCaretRightIcon } from '@phosphor-icons/react/dist/csr/CaretRight'
import { ChatCenteredIcon as PhosphorChatCenteredIcon } from '@phosphor-icons/react/dist/csr/ChatCentered'
import { ChatCircleIcon as PhosphorChatCircleIcon } from '@phosphor-icons/react/dist/csr/ChatCircle'
import { CheckIcon as PhosphorCheckIcon } from '@phosphor-icons/react/dist/csr/Check'
import { CheckCircleIcon as PhosphorCheckCircleIcon } from '@phosphor-icons/react/dist/csr/CheckCircle'
import { ClockIcon as PhosphorClockIcon } from '@phosphor-icons/react/dist/csr/Clock'
import { CopySimpleIcon as PhosphorCopySimpleIcon } from '@phosphor-icons/react/dist/csr/CopySimple'
import { DotsThreeIcon as PhosphorDotsThreeIcon } from '@phosphor-icons/react/dist/csr/DotsThree'
import { DownloadSimpleIcon as PhosphorDownloadSimpleIcon } from '@phosphor-icons/react/dist/csr/DownloadSimple'
import { ExportIcon as PhosphorExportIcon } from '@phosphor-icons/react/dist/csr/Export'
import { HouseLineIcon as PhosphorHouseLineIcon } from '@phosphor-icons/react/dist/csr/HouseLine'
import { ImageIcon as PhosphorImageIcon } from '@phosphor-icons/react/dist/csr/Image'
import { LightbulbIcon as PhosphorLightbulbIcon } from '@phosphor-icons/react/dist/csr/Lightbulb'
import { MagnifyingGlassIcon as PhosphorMagnifyingGlassIcon } from '@phosphor-icons/react/dist/csr/MagnifyingGlass'
import { PackageIcon as PhosphorPackageIcon } from '@phosphor-icons/react/dist/csr/Package'
import { PaperPlaneTiltIcon as PhosphorPaperPlaneTiltIcon } from '@phosphor-icons/react/dist/csr/PaperPlaneTilt'
import { PersonSimpleCircleIcon as PhosphorPersonSimpleCircleIcon } from '@phosphor-icons/react/dist/csr/PersonSimpleCircle'
import { PencilSimpleIcon as PhosphorPencilSimpleIcon } from '@phosphor-icons/react/dist/csr/PencilSimple'
import { PlusIcon as PhosphorPlusIcon } from '@phosphor-icons/react/dist/csr/Plus'
import { PlusCircleIcon as PhosphorPlusCircleIcon } from '@phosphor-icons/react/dist/csr/PlusCircle'
import { PushPinIcon as PhosphorPushPinIcon } from '@phosphor-icons/react/dist/csr/PushPin'
import { PushPinSlashIcon as PhosphorPushPinSlashIcon } from '@phosphor-icons/react/dist/csr/PushPinSlash'
import { ShareNetworkIcon as PhosphorShareNetworkIcon } from '@phosphor-icons/react/dist/csr/ShareNetwork'
import { SignOutIcon as PhosphorSignOutIcon } from '@phosphor-icons/react/dist/csr/SignOut'
import { StarIcon as PhosphorStarIcon } from '@phosphor-icons/react/dist/csr/Star'
import { ThumbsUpIcon as PhosphorThumbsUpIcon } from '@phosphor-icons/react/dist/csr/ThumbsUp'
import { TrashIcon as PhosphorTrashIcon } from '@phosphor-icons/react/dist/csr/Trash'
import { UserCircleIcon as PhosphorUserCircleIcon } from '@phosphor-icons/react/dist/csr/UserCircle'
import { UsersThreeIcon as PhosphorUsersThreeIcon } from '@phosphor-icons/react/dist/csr/UsersThree'
import { XIcon as PhosphorXIcon } from '@phosphor-icons/react/dist/csr/X'
import { XCircleIcon as PhosphorXCircleIcon } from '@phosphor-icons/react/dist/csr/XCircle'

const createBoldIcon = (Glyph) => {
    const BoldIcon = ({ color = 'currentColor', size = 24, ...props }) => (
        <Glyph
            {...props}
            aria-hidden="true"
            color={color}
            focusable="false"
            size={size}
            weight="bold"
        />
    )

    return BoldIcon
}

export const AddIcon = createBoldIcon(PhosphorPlusIcon)
export const AdminIcon = createBoldIcon(PhosphorPersonSimpleCircleIcon)
export const ArchiveIcon = createBoldIcon(PhosphorArchiveIcon)
export const AddCircleIcon = createBoldIcon(PhosphorPlusCircleIcon)
export const BackIcon = createBoldIcon(PhosphorCaretLeftIcon)
export const CheckIcon = createBoldIcon(PhosphorCheckIcon)
export const CheckCircleIcon = createBoldIcon(PhosphorCheckCircleIcon)
export const ClearIcon = createBoldIcon(PhosphorXCircleIcon)
export const CloseIcon = createBoldIcon(PhosphorXIcon)
export const CollectionIcon = createBoldIcon(PhosphorPackageIcon)
export const CopyIcon = createBoldIcon(PhosphorCopySimpleIcon)
export const DeleteIcon = createBoldIcon(PhosphorTrashIcon)
export const DreamIcon = createBoldIcon(PhosphorStarIcon)
export const EditIcon = createBoldIcon(PhosphorPencilSimpleIcon)
export const ExportIcon = createBoldIcon(PhosphorExportIcon)
export const FriendsIcon = createBoldIcon(PhosphorUsersThreeIcon)
export const HomeIcon = createBoldIcon(PhosphorHouseLineIcon)
export const ImageIcon = createBoldIcon(PhosphorImageIcon)
export const InstallIcon = createBoldIcon(PhosphorDownloadSimpleIcon)
export const LevelUpIcon = createBoldIcon(PhosphorCaretDoubleUpIcon)
export const LikeIcon = createBoldIcon(PhosphorThumbsUpIcon)
export const IdeaIcon = createBoldIcon(PhosphorLightbulbIcon)
export const LogoutIcon = createBoldIcon(PhosphorSignOutIcon)
export const MessageIcon = createBoldIcon(PhosphorChatCenteredIcon)
export const MoreIcon = createBoldIcon(PhosphorDotsThreeIcon)
export const NextIcon = createBoldIcon(PhosphorCaretRightIcon)
export const NotificationIcon = createBoldIcon(PhosphorBellIcon)
export const PinIcon = createBoldIcon(PhosphorPushPinIcon)
export const ProfileIcon = createBoldIcon(PhosphorUserCircleIcon)
export const SearchIcon = createBoldIcon(PhosphorMagnifyingGlassIcon)
export const ShareIcon = createBoldIcon(PhosphorShareNetworkIcon)
export const SuccessIcon = createBoldIcon(PhosphorCheckIcon)
export const SupportIcon = createBoldIcon(PhosphorChatCircleIcon)
export const TelegramIcon = createBoldIcon(PhosphorPaperPlaneTiltIcon)
export const TimeIcon = createBoldIcon(PhosphorClockIcon)
export const UnpinIcon = createBoldIcon(PhosphorPushPinSlashIcon)
